import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDHeadlineText } from '@facet-wealth/design';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'lg' },
  }, overrideReadOnly);
